module.exports = __webpack_public_path__ + "img/5.6f41a0d8.jpg";